function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.0726 0.358126C12.8297 0.127503 12.5151 0 12.1861 0C11.8184 0 11.4659 0.161247 11.2146 0.446878L4.84049 7.97868L2.70345 6.32813C2.40694 6.06563 2.02909 5.92125 1.63978 5.92125C1.15947 5.92125 0.704479 6.13875 0.392315 6.5175C-0.19406 7.22937 -0.115117 8.30629 0.575519 8.92437L3.92024 11.6788C4.15226 11.8856 4.44816 12 4.75429 12C5.12613 12 5.47927 11.8325 5.72516 11.5369L13.1781 2.25373C13.6452 1.69249 13.5988 0.859996 13.0727 0.358062L13.0726 0.358126Z"
});

var SvgCorrect = function SvgCorrect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCorrect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/correct.b5a132c8.svg";
export { ForwardRef as ReactComponent };